import { render } from "./TranscriptionUploadPromptPanel.vue?vue&type=template&id=15281a4e&scoped=true"
import script from "./TranscriptionUploadPromptPanel.vue?vue&type=script&lang=js"
export * from "./TranscriptionUploadPromptPanel.vue?vue&type=script&lang=js"

import "./TranscriptionUploadPromptPanel.vue?vue&type=style&index=0&id=15281a4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15281a4e"

export default script